import { useQuery } from "@tanstack/react-query";
import { qs, rawApi } from "@/lib/api";
import type { TelemetryOverview } from "@/lib/types";

export function useTelemetryOverview(days = 30) {
  return useQuery({
    queryKey: ["admin", "telemetry", "overview", { days }],
    queryFn: () => rawApi.get<TelemetryOverview>(`/api/v1/admin/telemetry/overview${qs({ days })}`),
  });
}
